import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material';

@Injectable()
export class SnackBarService {

  constructor(private snackBar: MatSnackBar) { }

  openSnackBarError(message: string, action: string, duration: number = 3000) {
    this.snackBar.open(message, action, {
      duration: duration,
      horizontalPosition: "right",
      panelClass: "notificationError",
    })
  }

  openSnackBarSuccess(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
      horizontalPosition: "right",
      panelClass: "notificationSuccess",
    })
  }
}
